import Image from "@Components/Image";
import MarqueeText from "@Components/MarqueeText";
import styles from "./SalesOfferSectionMobile.module.scss";
import { useAmberSales } from "hooks/useAmberSales";
import wrapperHOC from "@Utils/wrapperHOC";

const SalesOfferSectionMobile = ({ inventoryMeta }: any) => {
  const {
    isSaleOfferAvailableOnInventory,
    salesOfferTextForInventory,
    inventoryBrandImage,
    backgroundGradient,
    primaryColor,
    borderColor,
  }: any = useAmberSales({
    inventoryMeta,
    page: "PROPERTY",
  });

  if (!isSaleOfferAvailableOnInventory) return <></>;

  return (
    <div
      className={styles.saleOfferBannerContainer}
      style={{ background: primaryColor, borderColor }}
    >
      <div className={styles.imageContainer} style={{ background: backgroundGradient }}>
        <Image
          src={inventoryBrandImage}
          alt="sale-offer-banner"
          width="85%"
          height="auto"
          isEagerLoad
        />
      </div>
      <div className={styles.saleOfferText}>
        <MarqueeText text={salesOfferTextForInventory} startPosition="middle" width="100%" />
      </div>
    </div>
  );
};

export default wrapperHOC(SalesOfferSectionMobile, {
  componentName: "SalesOfferSectionMobile",
  showForChina: true,
});
